import React from 'react';
import { js_utils } from '../utils/frfr-js-utils';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
PROPS:
props.style
props.extraClass
*/

const UniImage = (props) => {
  let style = {};
  // if (props.style) {
  if (js_utils.is_object(props.style)) {
    style = props.style;
  }
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = props.extraClass;
  }
  return (
    <figure className={"unicompo-image " + extraClass}>
      <img className="unicompo-image__img" src={props.src} style={style} />
      {
        typeof props.caption === 'string' && (
          <figcaption>{props.caption}</figcaption>
        )
      }
    </figure>
  );
};

export default UniImage;